import { Component, computed, effect, EventEmitter, inject, Input, OnInit, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { ServiceBasicInfoFormStore } from './service-basic-info-form.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { FormGroup, Validators } from '@angular/forms';
import { serviceFormOptionsByType } from '../../../../../../../../types/src/services/enum/service-form.enum';
import { FileObject, ServiceTypeGridItemObject } from '@it2go/types';
import { ServiceBasicInfoFormStore2 } from './service-basic-info-form.store2';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { routeParams } from '../../../../shared/shared.global-service';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InputLogoComponent } from '../../common/input-logo/input-logo.component';
import { DateInputComponent } from '../../../../../components/kit/input/date-input/date-input.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { AsyncPipe, NgClass } from '@angular/common';
import {
    MultiSelectInputComponent,
} from '../../../../../components/kit/input/multi-select-input/multi-select-input.component';
import { AddressInputComponent } from '../../../../../components/kit/input/address-input/address-input.component';
import { PhoneInputComponent } from '../../../../../components/kit/input/phone-input/phone-input.component';
import { EmailInputComponent } from '../../../../../components/kit/input/text-input/email-input.component';
import { CheckInputComponent } from '../../../../../components/kit/input/check-input/check-input.component';
import { SelectUserComponent } from '../../common/select-user/select-user.component';
import { Divider } from '@openng/optimus-ui/divider';
import { SaveButtonComponent } from '../../../../../components/kit/button/save-button.component';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { ServiceTypeSelectComponent } from '../service-type-select/service-type-select.component';
import { featureOn } from '../../../../../feature-flag';

@Component({
    selector: 'app-service-basic-info-form',
    templateUrl: './service-basic-info-form.component.html',
    providers: [ServiceBasicInfoFormStore, ServiceBasicInfoFormStore2],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        InputLogoComponent,
        DateInputComponent,
        TextInputComponent,
        SelectInputComponent,
        AsyncPipe,
        NgClass,
        MultiSelectInputComponent,
        AddressInputComponent,
        PhoneInputComponent,
        EmailInputComponent,
        CheckInputComponent,
        SelectUserComponent,
        Divider,
        SaveButtonComponent,
        ButtonComponent,
        ServiceTypeSelectComponent,
    ],
})
export class ServiceBasicInfoFormComponent extends SubscriptionComponent implements OnInit {

    public readonly store2 = inject(ServiceBasicInfoFormStore2);
    public readonly translate = inject(TranslateService);
    protected readonly store = inject(ServiceBasicInfoFormStore);
    protected readonly featureOn = featureOn;


    @Input({ required: true }) serviceId!: number;
    @Input({ required: true }) form!: FormGroup;
    @Output() createEvent = new EventEmitter<void>();
    @Output() updateEvent = new EventEmitter<void>();
    @Output() cancelEvent = new EventEmitter<void>();

    protected serviceType = signal<ServiceTypeGridItemObject | null>(null);
    protected formOptions = computed(() => {
        return serviceFormOptionsByType(this.serviceType());
    });
    public isSocial = computed(() => {
        return this.serviceType()?.type === ServiceTypeEnum.SOCIAL;
    });
    public isHealthCare = computed(() => {
        return this.serviceType()?.type === ServiceTypeEnum.HEALTH_CARE;
    });

    constructor() {
        super();
        effect(() => {
            if (this.isHealthCare()) {
                this.form?.controls?.territorialVzpWorkplaceCode?.setValidators(Validators.required);
            } else {
                this.form?.controls?.territorialVzpWorkplaceCode?.clearValidators();
            }
            if (this.isSocial()) {
                this.form?.controls?.identifier?.setValidators(Validators.required);
            } else {
                this.form?.controls?.identifier?.clearValidators();
            }
            this.form?.controls?.territorialVzpWorkplaceCode?.updateValueAndValidity();
        });

        effect(async () => {
            if (routeParams.serviceId()) {
                const service = this.store2.globalGlobalStore.organizationStore.getServiceById(routeParams.serviceId())();
                if (service) {
                    const serviceTypeRes = await this.store2.api.getServiceTypes(FilterBuilder.filterById(service.serviceTypeId));
                    this.serviceType.set(serviceTypeRes?.items?.[0] || null);
                }
            }
        });
    }

    public async ngOnInit(): Promise<void> {
        this.store.api.getBankCodes(FilterBuilder.singlePage({}));
        this.store.api.getRegions(FilterBuilder.singlePage({}));
        this.store.api.getTerritorialVzpWorkplaces(FilterBuilder.filter({ limit: 100 }));
    }

    onFileUpload(file: FileObject) {
        const serviceBasicInfoId = this.form.get('id')?.value;
        if (serviceBasicInfoId) {
            this.store.api.updateServiceBasicInfo({
                id: serviceBasicInfoId,
                image: file.name,
            });
        }
    }
}
